import { AIModelKind } from '../smartbotAI';

export enum AIModelPricingRowKind {
  input = 'input',
  output = 'output',
  cached = 'cached'
}

export type AIModelPricingTier = {
  base: number;
  second?: number;
};

export type AIModelPricing = Record<AIModelPricingRowKind, AIModelPricingTier>;

export const orderAIModelPricingRows: AIModelPricingRowKind[] = [
  AIModelPricingRowKind.input,
  AIModelPricingRowKind.output,
  AIModelPricingRowKind.cached
];

export type AITariffication = Partial<Record<AIModelKind, AIModelPricing>>;
